<template>
  <div
    class="layout-wrapper layout-navbar-full"
    :class="[skinClasses]"
  >
    <nav class="header-navbar navbar navbar-expand-lg align-items-center navbar-light mb-1">
      <Navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </nav>

    <router-view />
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import Navbar from '../components/Navbar.vue'

export default {
  name: 'LayoutNoSideBar',
  components: {
    Navbar,
  },
  setup() {
    const { skin } = useAppConfig()
    const skinClasses = computed(() => ({
      'dark-layout': skin.value === 'dark',
    }))

    const isVerticalMenuActive = ref(false)

    const toggleVerticalMenuActive = () => {
      isVerticalMenuActive.value = !isVerticalMenuActive.value
    }

    return {
      skinClasses,
      toggleVerticalMenuActive,
    }
  },
}
</script>
